<!-- #63 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        {{ +$route.params.id === 0 ? "Add" : "Edit" }} configuration
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-form ref="form" lazy-validation>
      <v-card :loading="pageLoader">
        <v-card-title>
          <span class="body-1 font-weight-bold"
            >{{ +$route.params.id === 0 ? "Add" : "Edit" }}
            <i class="caption red--text ml-4"> * required field</i>
          </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="3" sm="6" class="pb-0">
              <v-text-field
                v-model="configDetails.key"
                label="Key"
                :rules="[(v) => (v && !!v.trim()) || 'Key is required.']"
                class="required"
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3" sm="6" class="pb-0">
              <v-text-field
                v-model="configDetails.value"
                label="Value"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6" class="pb-0">
              <v-text-field
                v-model="configDetails.token_value"
                label="Token"
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3" sm="6">
              <v-switch
                v-model="configDetails.encrypt_status"
                label="Encrypt Value"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-card-actions class="pb-0 pt-0">
              <v-btn
                v-if="$route.params.id == 0"
                color="primary"
                @click="save"
                :loading="saveloader"
                class="ma-2"
                >Save</v-btn
              >
              <v-btn
                v-if="$route.params.id > 0"
                color="primary"
                @click="save"
                :loading="saveloader"
                class="ma-2"
                >Update</v-btn
              >
              <v-btn
                class="ml-3"
                color="error"
                @click="$router.push('/list-configuration')"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-row>
        </v-card-text>
      </v-card>
    </v-form>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["clientTypes", "userTypes"]),
  },
  data() {
    return {
      pageLoader: false,
      saveloader: false,
      configDetails: {
        key: "",
        value: "",
        token_value: "",
        encrypt_status: false,
      },
      clientLoader: false,
      userLoader: false,
      clients: [],
      userGroup: [],
      value: [],
    };
  },
  created() {
    if (+this.$route.params.id !== 0) {
      this.fetchDetails();
    }
  },
  methods: {
    ...mapActions([
      "snackBar",
      "createconfig",
      "updateConfig",
      "getconfigDetails",
    ]),

    fetchDetails() {
      this.pageLoader = false;
      this.configDetails.id = this.$route.params.id;
      this.configDetails.key = this.$route.params.key;
      this.configDetails.value = this.$route.params.value;
      this.configDetails.token_value = this.$route.params.token_value;
      if (this.$route.params.encrypt_status == 2) {
        this.configDetails.encrypt_status = false;
      } else {
        this.configDetails.encrypt_status = this.$route.params.encrypt_status;
      }
    },

    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saveloader = true;
      Object.keys(this.configDetails).forEach((key) => {
        if (
          this.configDetails[key] !== true &&
          this.configDetails[key] !== false &&
          this.configDetails[key] !== null &&
          this.configDetails[key] !== undefined &&
          typeof this.configDetails[key] !== "number"
        ) {
          delete this.configDetails.id;
          if (this.configDetails[key].trim() === "") {
            this.configDetails[key] = "";
          }
        }
      });
      if (
        (this.configDetails.value == "" ||
          this.configDetails.value == undefined) &&
        (this.configDetails.token_value == "" ||
          this.configDetails.token_value == undefined)
      ) {
        this.snackBar({
          color: "warning",
          message: "Either Value or Token is required",
        });
        this.saveloader = false;

        return;
      }
      if (+this.$route.params.id !== 0) {
        this.updateConfig({
          id: this.$route.params.id,
          data: this.configDetails,
        })
          .then((res) => {
            this.saveloader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$router.replace({
              name: "ListConfiguration",
            });
          })
          .catch(() => {
            this.saveloader = false;
          });
      } else {
        this.createconfig(this.configDetails)
          .then((res) => {
            this.saveloader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$router.replace({
              name: "ListConfiguration",
            });
          })
          .catch(() => {
            this.saveloader = false;
          });
      }
    },
  },
};
</script>
